module.exports = __webpack_public_path__ + "static/omega_g4-31e232949855fd6bee41a32905904588.jpg";